<template>
  <div v-if="product">
    <slot name="logo"></slot>
    <h2 v-html-safe="product.payload.product"></h2>
    <slot name="video">
      <VideoPlayer class="mb-4" :video-id="videoId" :product="product.internalName" />
    </slot>
    <p v-html-safe="product.payload.message.join('<br><br>')"></p>
    <p class="disclaimer-message">{{ $t(`message.spotlightV2.categories.protection.disclaimer`) }}</p>
  </div>
</template>

<script>
const VideoPlayer = () => import('@/modules/spotlight/components/SpotlightVideoPlayer.vue');

export default {
  name: 'ProtectionBase',
  components: {
    VideoPlayer,
  },
  props: {
    product: {
      validator: prop => typeof prop === 'object' || prop === undefined,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    videoId() {
      const isEnglish = this.$i18n.locale.includes('en');
      return isEnglish ? this.videoIds[this.product.internalName].en : this.videoIds[this.product.internalName].fr;
    },
    videoIds() {
      return {
        [this.enums.SpotlightConstants.internalNames.autoverify['VEHICLE-SERVICE-CONTRACTS']]: {
          en: 'eFQBbUuvokg',
          fr: 'z4wDD7Luea0',
        },
        [this.enums.SpotlightConstants.internalNames.autoverify['PREPAID-MAINTENANCE-PLANS']]: {
          en: 'ghpk7fmZZJM',
          fr: 'lKM_lxVrQ_k',
        },
        [this.enums.SpotlightConstants.internalNames.autoverify['GAP-INSURANCE']]: {
          en: 'ljfZQklKtV8',
          fr: '-DtmSATRUtc',
        },
        [this.enums.SpotlightConstants.internalNames.autoverify['TIRE-WHEEL-PLAN']]: {
          en: 'qnYo7Unsf24',
          fr: 'JIA65sk4r9Y',
        },
        [this.enums.SpotlightConstants.internalNames.autoverify['INTERIOR-EXTERIOR-PLANS']]: {
          en: 'za5aW1LilBQ',
          fr: 'xru-L5suTUQ',
        },
      };
    },
  },
};
</script>

<style scoped lang="scss">
p {
  font-weight: normal;
  line-height: 24px;
}

.disclaimer-message {
  font-size: 14px;
  font-style: italic;
  color: rgb(109, 119, 131);
  padding-top: 20px;
}
</style>
